import { NAVIGO_STATUS } from "modules/appointments/helper/appointmentConstants";

/**
 * Which Call-note variant the board draws for an appointment (3108:14316).
 *
 * The five popups are per call OUTCOME, so the variant is the one part of this
 * mockup that follows real data — a reviewer opening a cancelled appointment
 * should see the cancelled shell, not "Completed" over sample text.
 *
 * Anything outside the five mapped states falls back to the pre-call variant:
 * it is the only one that promises nothing about how the call went.
 */
const BY_STATUS = {
  [NAVIGO_STATUS.COMPLETED]: "completed",
  [NAVIGO_STATUS.SUCCESSFUL_HRA]: "completed",
  [NAVIGO_STATUS.SUCCESSFUL_PRC]: "completed",
  [NAVIGO_STATUS.CANCELLED]: "cancelled",
  [NAVIGO_STATUS.DECLINED]: "cancelled",
  [NAVIGO_STATUS.NO_SHOW]: "noShow",
  [NAVIGO_STATUS.NOT_ANSWERED]: "noShow",
  [NAVIGO_STATUS.NOT_ANSWERED_3_ATTEMPTS]: "noShow",
  [NAVIGO_STATUS.NOT_REACHABLE]: "noShow",
  [NAVIGO_STATUS.RESCHEDULE_REQUESTED]: "rescheduled",
  /* These four were in neither map, so the header read "Confirmed" in success
     green over a message about a call that had already failed or been called
     off. There is no prefill to keep in step with any more: the message starts
     empty and the operator writes it. */
  [NAVIGO_STATUS.REPORT_GENERATED]: "completed",
  [NAVIGO_STATUS.NOT_ELIGIBLE]: "cancelled",
  [NAVIGO_STATUS.CALL_LATER]: "rescheduled",
  /* A call that is happening right now is not an outcome, and it certainly is
     not a green "Confirmed" — which is what it read as, because IN_PROGRESS was
     missing here and the fallback below supplied the wrong word in the wrong
     colour. */
  [NAVIGO_STATUS.IN_PROGRESS]: "inProgress",
  [NAVIGO_STATUS.CONFIRMED]: "confirmed",
};

/**
 * The variant now decides only the TONE — the words come from STATUS_LABEL, so
 * a status nobody mapped still names itself correctly instead of borrowing
 * another one's label.
 *
 * The fallback is neutral for the same reason. Nine statuses reach it
 * (Scheduled, Phlebo assigned, Pickup, Sample collected/received, Request to
 * lab, Lab visited and the two legacy spellings), none of which says anything
 * about how a call went, and every one of them used to render in success green.
 */
export const callNoteVariant = (status) => BY_STATUS[status] || "pending";

export default callNoteVariant;
